import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { AuthContext } from '../context/AuthContext';
import { isAdminAccount } from '../utils/permissions';
import LoadingSpinner from './global/LoadingSpinner';

/**
 * Route wrapper that requires authentication AND admin access.
 * Non-admin authenticated users get redirected home.
 */
function AdminRoute({ children }) {
  const { user, token, loading } = useContext(AuthContext);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (!user || !token) {
    return <Navigate to="/login" replace />;
  }

  if (!isAdminAccount(user)) {
    return <Navigate to="/" replace />;
  }

  return children;
}

AdminRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AdminRoute;
